import { applyMiddleware, createStore, Store } from "redux";
import { createEpicMiddleware } from "redux-observable";
import { IApplicationState, RootActions, RootEpic, RootReducer } from "./store";
import { composeWithDevTools } from '@redux-devtools/extension';

export default function ConfigureStore() : Store<IApplicationState, RootActions> {
    const epicMiddleware = createEpicMiddleware();
    const store = createStore(RootReducer, undefined,  composeWithDevTools(applyMiddleware(epicMiddleware)));
    epicMiddleware.run(RootEpic);
    return store;
}